import { Box } from '@mui/material';
import React, { useContext } from 'react'
import Page from '../page';
import Linha1Relatorio from './component/linha1';
import Linha10Relatorio from './component/linha10';
import Linha11Relatorio from './component/linha11';
import Linha12Relatorio from './component/linha12';
import Linha2Relatorio from './component/linha2';
import Linha3Relatorio from './component/linha3';
import Linha4Relatorio from './component/linha4';
import Linha5Relatorio from './component/linha5';
import Linha6Relatorio from './component/linha6';
import Linha7Relatorio from './component/linha7';
import Linha8Relatorio from './component/linha8';
import Linha9Relatorio from './component/linha9';
import { DoençaCID } from '../../../utils/inquiries';
import { LMEPrintContext } from '../../../pages/print/printjob';
import RelatorioOp from './component/op';

// DEPOIS PASSAR ELE PARA UM ARQUIVO INDEX DENTRO DE UMA PASTA AR, EA, APSO E AIJ
// O PROBLEMA É QUE ISSO VAI FAZER DAR PROBLEMA EM TODAS AS IMPORTAÇÕES DOS ARQUIVOS USADOS
const RelatorioAREAAPAIJ = () => {

    return (
        <>
            <Page size="a4">
                <Box
                    sx={{
                        display: 'flex',
                        borderBlockColor: "black",
                        borderStyle: "solid",
                        borderWidth: "5px",
                        p: 1,
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: "100%",
                            width: "100%",
                            gap: 0.2,
                        }}
                    >
                        <Linha1Relatorio />
                        <Linha2Relatorio />
                        <Linha3Relatorio />
                        <Linha4Relatorio />
                        <Linha5Relatorio />
                        <Linha6Relatorio />
                        <Linha7Relatorio />
                        <Linha8Relatorio />
                        <Linha9Relatorio />
                        <Linha10Relatorio />
                        <Linha11Relatorio />
                        <Linha12Relatorio />
                    </Box>
                </Box>
            </Page>
        </>
    )
}



const FactoryRelatorio = () => {

    const lme = useContext(LMEPrintContext)

    if (DoençaCID(lme.cid10) === 'op') return <RelatorioOp />

    return <RelatorioAREAAPAIJ />
}

export default FactoryRelatorio